import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["gauge", "bar1", "bar2", "bar3", "label"]

  #timeout = null

  connect() {
    this.currentScore = null
  }

  check(event) {
    const password = event.target.value

    if (password.length === 0) {
      this.gaugeTarget.classList.add("hidden")
      this.currentScore = null
      return
    }

    clearTimeout(this.#timeout)
    this.#timeout = setTimeout(() => this.#fetchScore(password), 300)
  }

  async #fetchScore(password) {
    const response = await fetch("/password_strength", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ password })
    })

    const { score } = await response.json()
    this.currentScore = score
    this.#updateGauge()
  }

  #updateGauge() {
    this.gaugeTarget.classList.remove("hidden")

    const colors = { weak: "bg-red-500", medium: "bg-secondary-500", strong: "bg-primary-500" }
    const labels = { weak: "Faible", medium: "Moyen", strong: "Fort" }
    const textColors = { weak: "text-red-500", medium: "text-secondary-500", strong: "text-primary-500" }
    const active = { weak: 1, medium: 2, strong: 3 }

    const count = active[this.currentScore]
    const color = colors[this.currentScore]

    ;[this.bar1Target, this.bar2Target, this.bar3Target].forEach((bar, i) => {
      bar.className = "h-full w-full rounded-full transition-all duration-300"
      if (i < count) {
        bar.classList.add(color)
      } else {
        bar.classList.add("bg-transparent")
      }
    })

    this.labelTarget.textContent = labels[this.currentScore]
    this.labelTarget.className = `text-xs font-medium transition-colors duration-300 ${textColors[this.currentScore]}`
  }
}
